import React from 'react';
import styled from 'styled-components';
import { DATA_GRABS } from '../design';
import { COLORS } from '../styles';

// Only the block-end edge is drawn, but the color is set on all four sides:
// the editor's design panel reads its swatch back from the element's computed
// `border-color`, and a per-side value serializes as an unparseable
// four-value shorthand.
const Hr = styled.hr`
    border: none;
    border-color: ${COLORS.border};
    border-block-end-style: solid;
    border-block-end-width: 1px;
    margin: 0;
    block-size: 0;
`;

const Divider: React.FC = () => (
    <Hr aria-hidden='true' data-grab={DATA_GRABS.dividers} />
);

export default Divider;
